import { Component, AfterViewInit, OnChanges, Output, EventEmitter, DoCheck, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { OwnerService } from '../../../service/owner/owner.service';
import { PrefService } from '../../../service/pref/pref.service';
import { SalesofficeService } from '../../../service/salesoffice/salesoffice.service';
import { WhService } from '../../../service/wh/wh.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa9193',
  templateUrl: './wa9193.component.html',
  styleUrls: ['./wa9193.component.scss']
})
export class Wa9193Component implements AfterViewInit, OnChanges, DoCheck {
  public componentTitle = 'WA9193:荷主マスタ修正';
  // public ownerId: FormControl;
  public ownerCd: string;
  public ownerTx: FormControl;
  public ownerfullname1Tx: FormControl;
  public ownerfullname2Tx: FormControl;
  public owneraccCd: FormControl;
  public ownerpostalCd: FormControl;
  public owneraddress1Tx: FormControl;
  public owneraddress2Tx: FormControl;
  public owneraddress3Tx: FormControl;
  public ownertelTx: FormControl;
  public yamatobasenoCd: FormControl;
  public validation = validation;
  public bookendNr = 0;
  public invstockfreqNr = 0;
  // public delipriceFl: boolean = false;
  public owners: any;
  public prefs: any;
  public salesoffices: any;
  public whs: any;
  public ownerId: number = 0;
  public prefTx: string;
  public salesofficeId: number;
  public whCd: string;
  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public rootFormGroup: FormGroup;
  public dump = '';
  private errorInfo = '';
  private openotherwindow: boolean = false;
  @Output() onSubmitClick = new EventEmitter();
  @Input() rowdata: object = [];

  private isDelayHide = true;

  private ownerTxCls = '';
  private ownerfullname1TxCls = '';
  private ownerfullname2TxCls = '';
  private ownerpostalCdCls = '';
  private owneraddress1TxCls = '';
  private owneraddress2TxCls = '';
  private owneraddress3TxCls = '';
  private ownertelTxCls = '';
  private whCdCls = '';
  private salesofficeIdCls = '';
  private bookendNrCls = '';
  private invstockfreqNrCls = '';
  private owneraccCdCls = '';
  private yamatobasenoCdCls = '';

  constructor(
    private ownerService: OwnerService,
    private prefService: PrefService,
    private salesofficeService: SalesofficeService,
    private whService: WhService,
    private commonService: CommonService
  ) {
    sessionStorage.removeItem('wa9193openotherwindow');
    const ownerSelect: object = this.rowdata;
    this.ownerId = ownerSelect['ownerId'];
    this.ownerCd = ownerSelect['ownerCd'];
    this.ownerTx = ownerSelect['ownerTx'];
    this.ownerfullname1Tx = ownerSelect['ownerfullname1Tx'];
    this.ownerfullname2Tx = ownerSelect['ownerfullname2Tx'];
    this.owneraccCd = ownerSelect['owneraccCd'];
    this.ownerpostalCd = ownerSelect['ownerpostalCd'];
    this.owneraddress1Tx = ownerSelect['owneraddress1Tx'];
    this.owneraddress2Tx = ownerSelect['owneraddress2Tx'];
    this.owneraddress3Tx = ownerSelect['owneraddress3Tx'];
    this.ownertelTx = ownerSelect['ownertelTx'];
    this.yamatobasenoCd = ownerSelect['yamatobasenoCd'];
    this.bookendNr = ownerSelect['bookendNr'];
    this.invstockfreqNr = ownerSelect['invstockfreqNr'];
    // if (ownerSelect['delipriceFl'] === 1) {
    //   this.delipriceFl = true;
    // } else {
    //   this.delipriceFl = false;
    // }
    // this.delipriceFl = ownerSelect['delipriceFl'];
    this.whCd = ownerSelect['whCd'];
    this.salesofficeId = ownerSelect['salesofficeId'];
    this.ownerTx = new FormControl(this.ownerTx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerTx.maxLength)
    ]);
    this.ownerfullname1Tx = new FormControl(this.ownerfullname1Tx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname1Tx.maxLength)
    ]);
    this.ownerfullname2Tx = new FormControl(this.ownerfullname2Tx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.ownerfullname2Tx.maxLength)
    ]);
    this.owneraccCd = new FormControl(this.owneraccCd, [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.owneraccCd.maxLength)
    ]);
    this.ownerpostalCd = new FormControl(this.ownerpostalCd, [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.pattern(validation.ownerpostalCd.postcode),
      Validators.maxLength(validation.ownerpostalCd.maxLength)
    ]);
    this.owneraddress1Tx = new FormControl(this.owneraddress1Tx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress1Tx.maxLength)
    ]);
    this.owneraddress2Tx = new FormControl(this.owneraddress2Tx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress2Tx.maxLength)
    ]);
    this.owneraddress3Tx = new FormControl(this.owneraddress3Tx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.owneraddress3Tx.maxLength)
    ]);
    this.ownertelTx = new FormControl(this.ownertelTx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.ownertelTx.tel),
      Validators.maxLength(validation.ownertelTx.maxLength)
    ]);
    this.yamatobasenoCd = new FormControl(this.yamatobasenoCd, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.yamatobasenoCd.maxLength)
    ]);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.salesofficeService
      .get()
      .then(__outputJson => {
        this.salesoffices = __outputJson.salesoffices;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.whService
      .get()
      .then(__outputJson => {
        this.whs = __outputJson.whs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    let errors = false;
    const ownerTx = this.ownerTx.value.trim();
    const ownerfullname1Tx = this.ownerfullname1Tx.value.trim();
    const ownerfullname2Tx = this.ownerfullname2Tx.value.trim();
    const owneraccCd = this.owneraccCd.value.trim();
    const ownerpostalCd = this.ownerpostalCd.value.trim();
    const owneraddress1Tx = this.owneraddress1Tx.value.trim();
    const owneraddress2Tx = this.owneraddress2Tx.value.trim();
    const owneraddress3Tx = this.owneraddress3Tx.value.trim();
    const ownertelTx = this.ownertelTx.value.trim();

    let yamatobasenoCd = '';
    if (this.yamatobasenoCd.value !== null) {
      yamatobasenoCd = this.yamatobasenoCd.value.trim();
    }

    if (this.ownerTx.errors !== null) {
      this.ownerTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerfullname1Tx.errors !== null) {
      this.ownerfullname1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerfullname2Tx.errors !== null) {
      this.ownerfullname2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraccCd.errors !== null) {
      this.owneraccCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownerpostalCd.errors !== null) {
      this.ownerpostalCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress1Tx.errors !== null) {
      this.owneraddress1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress2Tx.errors !== null) {
      this.owneraddress2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.owneraddress3Tx.errors !== null) {
      this.owneraddress3Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.ownertelTx.errors !== null) {
      this.ownertelTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.yamatobasenoCd.errors !== null) {
      this.yamatobasenoCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      this.working = false;
      return;
    }

    if (this.whCd === undefined) {
      this.errorInfo = '倉庫名を選択してください';
      return;
    }
    if (this.salesofficeId === undefined) {
      this.errorInfo = '営業所名を選択してください';
      return;
    }
    // if (this.bookendNr !== 5 && this.bookendNr !== 10 && this.bookendNr !== 15 && this.bookendNr !== 20 && this.bookendNr !== 25 && this.bookendNr !== 99) {
    //   this.errorInfo = '請求締め日が正しくありません';
    //   return;
    // }
    // if (this.invstockfreqNr !== 1 && this.invstockfreqNr !== 3) {
    //   this.errorInfo = '請求・保管期数が正しくありません';
    //   return;
    // }

    // let tmpDelipriceFl = 0;
    // if (this.delipriceFl === true) {
    //   tmpDelipriceFl = 1;
    // } else {
    //   tmpDelipriceFl = 0;
    // }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.ownerService
      .put(
        this.ownerId,
        this.ownerCd,
        ownerTx,
        ownerfullname1Tx,
        ownerfullname2Tx,
        owneraccCd,
        '〒' + ownerpostalCd,
        owneraddress1Tx,
        owneraddress2Tx,
        owneraddress3Tx,
        ownertelTx,
        yamatobasenoCd,
        this.whCd,
        this.salesofficeId,
        this.bookendNr,
        this.invstockfreqNr,
        0,
        'wa9193'
      )
      .then(outputJson => {
        this.cancel();
        this.onSubmitClick.emit();
        sessionStorage.setItem('wa9193upd', 'ok');
        this.working2 = false;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessageFirst(error);
        this.working2 = false;
      });
  }

  ngOnChanges() {
    if (this.rowdata !== [] && sessionStorage.getItem('wa9193openotherwindow') === 'open') {
      const ownerSelect: object = this.rowdata;
      this.ownerId = ownerSelect['ownerId'];
      this.ownerCd = ownerSelect['ownerCd'];
      this.ownerTx = ownerSelect['ownerTx'];
      this.ownerfullname1Tx = ownerSelect['ownerfullname1Tx'];
      this.ownerfullname2Tx = ownerSelect['ownerfullname2Tx'];
      this.owneraccCd = ownerSelect['owneraccCd'];
      this.ownerpostalCd = ownerSelect['ownerpostalCd'].substr(1);
      this.owneraddress1Tx = ownerSelect['owneraddress1Tx'];
      this.owneraddress2Tx = ownerSelect['owneraddress2Tx'];
      this.owneraddress3Tx = ownerSelect['owneraddress3Tx'];
      this.ownertelTx = ownerSelect['ownertelTx'];
      this.yamatobasenoCd = ownerSelect['yamatobasenoCd'];
      this.bookendNr = ownerSelect['bookendNr'];
      this.invstockfreqNr = ownerSelect['invstockfreqNr'];
      // if (ownerSelect['delipriceFl'] === 1) {
      //   this.delipriceFl = true;
      // } else {
      //   this.delipriceFl = false;
      // }
      // this.delipriceFl = ownerSelect['delipriceFl'];
      this.whCd = ownerSelect['whCd'];
      this.salesofficeId = ownerSelect['salesofficeId'];
      this.ownerTx = new FormControl(this.ownerTx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.ownerTx.maxLength)
      ]);
      this.ownerfullname1Tx = new FormControl(this.ownerfullname1Tx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.ownerfullname1Tx.maxLength)
      ]);
      this.ownerfullname2Tx = new FormControl(this.ownerfullname2Tx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.ownerfullname2Tx.maxLength)
      ]);
      this.owneraccCd = new FormControl(this.owneraccCd, [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.owneraccCd.maxLength)
      ]);
      this.ownerpostalCd = new FormControl(this.ownerpostalCd, [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.pattern(validation.ownerpostalCd.postcode),
        Validators.maxLength(validation.ownerpostalCd.maxLength)
      ]);
      this.owneraddress1Tx = new FormControl(this.owneraddress1Tx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.owneraddress1Tx.maxLength)
      ]);
      this.owneraddress2Tx = new FormControl(this.owneraddress2Tx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.owneraddress2Tx.maxLength)
      ]);
      this.owneraddress3Tx = new FormControl(this.owneraddress3Tx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.owneraddress3Tx.maxLength)
      ]);
      this.ownertelTx = new FormControl(this.ownertelTx, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.ownertelTx.tel),
        Validators.maxLength(validation.ownertelTx.maxLength)
      ]);
      this.yamatobasenoCd = new FormControl(this.yamatobasenoCd, [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.yamatobasenoCd.maxLength)
      ]);
    }
  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9193openotherwindow') === 'open') {
      this.openotherwindow = true;
      this.isDelayHide = false;
    }

    if (this.rowdata !== []) {
      if (
        !this.ownerTx.errors &&
        !this.ownerfullname1Tx.errors &&
        !this.ownerfullname2Tx.errors &&
        !this.owneraccCd.errors &&
        !this.ownerpostalCd.errors &&
        !this.owneraddress1Tx.errors &&
        !this.owneraddress2Tx.errors &&
        !this.owneraddress3Tx.errors &&
        !this.ownertelTx.errors &&
        !this.yamatobasenoCd.errors &&
        this.ownerTx.value !== '' &&
        this.ownerfullname1Tx.value !== '' &&
        this.ownerpostalCd.value !== '' &&
        this.owneraddress1Tx.value !== '' &&
        this.ownertelTx.value !== '' &&
        this.whCd !== '' &&
        this.salesofficeId !== 0 &&
        this.bookendNr !== 0 &&
        this.invstockfreqNr !== 0
      ) {
        if (
          this.rowdata['ownerTx'] !== this.ownerTx.value ||
          this.rowdata['ownerfullname1Tx'] !== this.ownerfullname1Tx.value ||
          this.rowdata['ownerfullname2Tx'] !== this.ownerfullname2Tx.value ||
          this.rowdata['owneraccCd'] !== this.owneraccCd.value ||
          this.rowdata['ownerpostalCd'].substr(1) !== this.ownerpostalCd.value ||
          this.rowdata['owneraddress1Tx'] !== this.owneraddress1Tx.value ||
          this.rowdata['owneraddress2Tx'] !== this.owneraddress2Tx.value ||
          this.rowdata['owneraddress3Tx'] !== this.owneraddress3Tx.value ||
          this.rowdata['ownertelTx'] !== this.ownertelTx.value ||
          this.rowdata['yamatobasenoCd'] !== this.yamatobasenoCd.value ||
          this.rowdata['whCd'] !== this.whCd ||
          this.rowdata['salesofficeId'] !== this.salesofficeId ||
          this.rowdata['bookendNr'] !== this.bookendNr ||
          this.rowdata['invstockfreqNr'] !== this.invstockfreqNr
        ) {
          this.working = true;
        } else {
          this.working = false;
        }
      } else {
        this.working = false;
      }

      if (sessionStorage.getItem('wa9193openotherwindow') === 'open') {
        this.ownerTxCls = this.rowdata['ownerTx'] === this.ownerTx.value ? 'normal' : this.ownerTx.value.length == 0 ? '' : this.ownerTx.errors == null ? 'active' : 'error';
        this.ownerfullname1TxCls =
          this.rowdata['ownerfullname1Tx'] === this.ownerfullname1Tx.value
            ? 'normal'
            : this.ownerfullname1Tx.value.length == 0
              ? ''
              : this.ownerfullname1Tx.errors == null
                ? 'active'
                : 'error';
        this.ownerfullname2TxCls =
          this.rowdata['ownerfullname2Tx'] === this.ownerfullname2Tx.value
            ? 'normal'
            : this.ownerfullname2Tx.value.length == 0
              ? ''
              : this.ownerfullname2Tx.errors == null
                ? 'active'
                : 'error';
        this.ownerpostalCdCls =
          this.rowdata['ownerpostalCd'].substr(1) === this.ownerpostalCd.value
            ? 'normal'
            : this.ownerpostalCd.value.length == 0
              ? ''
              : this.ownerpostalCd.errors == null
                ? 'active'
                : 'error';
        this.owneraddress1TxCls =
          this.rowdata['owneraddress1Tx'] === this.owneraddress1Tx.value
            ? 'normal'
            : this.owneraddress1Tx.value.length == 0
              ? ''
              : this.owneraddress1Tx.errors == null
                ? 'active'
                : 'error';
        this.owneraddress2TxCls =
          this.rowdata['owneraddress2Tx'] === this.owneraddress2Tx.value
            ? 'normal'
            : this.owneraddress2Tx.value.length == 0
              ? ''
              : this.owneraddress2Tx.errors == null
                ? 'active'
                : 'error';
        this.owneraddress3TxCls =
          this.rowdata['owneraddress3Tx'] === this.owneraddress3Tx.value
            ? 'normal'
            : this.owneraddress3Tx.value.length == 0
              ? ''
              : this.owneraddress3Tx.errors == null
                ? 'active'
                : 'error';
        this.ownertelTxCls =
          this.rowdata['ownertelTx'] === this.ownertelTx.value ? 'normal' : this.ownertelTx.value.length == 0 ? '' : this.ownertelTx.errors == null ? 'active' : 'error';
        this.whCdCls = this.rowdata['whCd'] === this.whCd ? 'normal' : this.whCd == null || this.whCd.length == 0 ? '' : 'active';
        this.salesofficeIdCls =
          this.rowdata['salesofficeId'] + '' === this.salesofficeId + '' ? 'normal' : this.salesofficeId == null || (this.salesofficeId + '').length == 0 ? '' : 'active';
        this.bookendNrCls = this.rowdata['bookendNr'] + '' === this.bookendNr + '' ? 'normal' : this.bookendNr == null || (this.bookendNr + '').length == 0 ? '' : 'active';
        this.invstockfreqNrCls =
          this.rowdata['invstockfreqNr'] + '' === this.invstockfreqNr + '' ? 'normal' : this.invstockfreqNr == null || (this.invstockfreqNr + '').length == 0 ? '' : 'active';
        this.owneraccCdCls =
          this.rowdata['owneraccCd'] === this.owneraccCd.value ? 'normal' : this.owneraccCd.value.length == 0 ? '' : this.owneraccCd.errors == null ? 'active' : 'error';
        this.yamatobasenoCdCls =
          this.rowdata['yamatobasenoCd'] === this.yamatobasenoCd.value
            ? 'normal'
            : this.yamatobasenoCd.value.length == 0
              ? ''
              : this.yamatobasenoCd.errors == null
                ? 'active'
                : 'error';
      }
    }
  }
  cancel() {
    sessionStorage.removeItem('wa9193openotherwindow');
    this.openotherwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.working = false;
    this.errorInfo = '';
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9193/wa9193.component.ts